import React from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';

class ContainerResizeListener extends React.PureComponent {

  componentDidMount() {
    this.observer = new ResizeObserver(this.handleResize);

    if (!this.props.disabled) {
      this.initListener();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.disabled && !nextProps.disabled) {
      this.initListener();
    }

    if (!this.props.disabled && nextProps.disabled) {
      this.removeListener();
    }
  }

  componentWillUnmount() {
    this.removeListener();
  }

  initListener() {
    this.observer.observe(this.container);
    this.handleResize();
  }

  removeListener() {
    this.observer.disconnect();
  }

  handleResize = () => {
    this.props.onResize({
      width: this.container.clientWidth,
      height: this.container.clientHeight,
    });
  };

  render() {
    return (
      <div id={this.props.id} ref={ container => this.container = container } className={this.props.className}>
        {this.props.children}
      </div>
    );
  }
}

ContainerResizeListener.defaultProps = {
  onResize: () => {},
  disabled: false,
};

ContainerResizeListener.propTypes = {
  onResize: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ContainerResizeListener;